import React from 'react';
import { Container, Typography, Box, Divider, Table, TableHead, TableBody, TableRow, TableCell, Paper } from '@mui/material';

const CookiePolicyPage = () => (
  <Container maxWidth="md" sx={{ py: 6 }}>
    <Typography variant="h3" component="h1" fontWeight="bold" gutterBottom>
      Cookie Policy
    </Typography>
    <Typography variant="body2" color="text.secondary" gutterBottom>
      Ultimo aggiornamento: maggio 2025
    </Typography>
    <Divider sx={{ my: 3 }} />

    <Section title="Cosa sono i cookie">
      <p>I cookie sono piccoli file di testo che i siti web salvano sul dispositivo dell'utente durante la navigazione. Servono a far funzionare il sito correttamente, a memorizzare le preferenze dell'utente e — se l'utente acconsente — a raccogliere informazioni statistiche sulla navigazione.</p>
    </Section>

    <Section title="Cookie utilizzati da questo sito">
      <Paper variant="outlined" sx={{ mt: 2, mb: 2, overflowX: 'auto' }}>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
              <TableCell><strong>Nome</strong></TableCell>
              <TableCell><strong>Tipo</strong></TableCell>
              <TableCell><strong>Finalità</strong></TableCell>
              <TableCell><strong>Durata</strong></TableCell>
              <TableCell><strong>Consenso richiesto</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>cookie_consent</TableCell>
              <TableCell>Tecnico</TableCell>
              <TableCell>Memorizza la preferenza sul consenso ai cookie</TableCell>
              <TableCell>6 mesi</TableCell>
              <TableCell>No</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>i18nextLng</TableCell>
              <TableCell>Tecnico</TableCell>
              <TableCell>Memorizza la lingua selezionata dall'utente</TableCell>
              <TableCell>1 anno</TableCell>
              <TableCell>No</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Paper>
      <p>Attualmente questo sito utilizza esclusivamente cookie tecnici necessari al funzionamento. Non sono presenti cookie di profilazione o di marketing di terze parti.</p>
    </Section>

    <Section title="Come gestire i cookie">
      <p>L'utente può gestire o disabilitare i cookie direttamente dalle impostazioni del proprio browser:</p>
      <ul>
        <li><strong>Chrome:</strong> Impostazioni → Privacy e sicurezza → Cookie e altri dati dei siti</li>
        <li><strong>Firefox:</strong> Impostazioni → Privacy e sicurezza → Cookie e dati dei siti web</li>
        <li><strong>Safari:</strong> Preferenze → Privacy → Gestisci dati dei siti web</li>
        <li><strong>Edge:</strong> Impostazioni → Cookie e autorizzazioni dei siti</li>
      </ul>
      <p>La disabilitazione dei cookie tecnici potrebbe compromettere il corretto funzionamento del sito.</p>
    </Section>

    <Section title="Revocare il consenso">
      <p>Il consenso ai cookie non tecnici può essere revocato in qualsiasi momento cancellando il cookie <em>cookie_consent</em> dal browser oppure contattandoci a <strong>Info@watchpassion.net</strong>.</p>
    </Section>
  </Container>
);

const Section = ({ title, children }) => (
  <Box sx={{ mb: 4 }}>
    <Typography variant="h6" fontWeight="bold" gutterBottom>{title}</Typography>
    <Typography variant="body1" component="div" color="text.secondary" sx={{ lineHeight: 1.8 }}>
      {children}
    </Typography>
  </Box>
);

export default CookiePolicyPage;
